import _findKey from 'lodash/findKey';
import _get from 'lodash/get';

// eslint-disable-next-line no-underscore-dangle
const _devices = {
  mobile: {
    maxWidth: 640,
  },
  desktop: {
    minWidth: 640,
  },
};

export const devices = Object.keys(_devices).reduce(
  (deviceObj, deviceKey) => ({
    ...deviceObj,
    [deviceKey]: deviceKey,
  }),
  {}
);

export const getDeviceForWidth = (width = 0) =>
  _findKey(_devices, (device) => {
    const deviceMinWidth = _get(device, 'minWidth', 0);
    const deviceMaxWidth = _get(device, 'maxWidth', 9999999999);
    return deviceMinWidth <= width && deviceMaxWidth >= width;
  });
